module.exports = __webpack_public_path__ + "static/media/21.cd305bbc.png";